import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../components/atomic/Buttons/Button';

class ModalButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  openModal = () => {
    const { onClick } = this.props;
    if (onClick) {
      onClick();
    }
    this.setState({ modalOpen: true });
  };

  closeModal = () => {
    this.setState({ modalOpen: false });
  }

  handleClose = () => {
    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
    if (this._isMounted) {
      this.setState({ modalOpen: false });
    }
  };

  render() {
    const {
      children,
      className,
      color,
      modalComponent,
      variant
    } = this.props;
    const { modalOpen } = this.state;

    const ModalComponent = React.cloneElement(modalComponent, {
      open: modalOpen,
      onBackdropClick: this.closeModal,
      onClose: this.handleClose,
    })
    
    return (
      <React.Fragment>
        <Button onClick={this.openModal} className={className} color={color} variant={variant}>
          {children}
        </Button>
        {ModalComponent}
      </React.Fragment>
    );
  }
}

ModalButton.propTypes = {
  modalComponent: PropTypes.element.isRequired,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
};

export default ModalButton;
